import { render, staticRenderFns } from "./LegendItem.vue?vue&type=template&id=38593901&scoped=true&"
import script from "./LegendItem.vue?vue&type=script&lang=ts&"
export * from "./LegendItem.vue?vue&type=script&lang=ts&"
import style0 from "./LegendItem.vue?vue&type=style&index=0&id=38593901&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38593901",
  null
  
)

export default component.exports